// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2DBrn","title":"FrontImage_title__3oBA3"};